import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDeIKEQkD2dY5Z02IMCb4PYiXRrAGIONA0",
  authDomain: "mogul-cloud.firebaseapp.com",
  databaseURL: "https://mogul-cloud-default-rtdb.firebaseio.com",
  projectId: "mogul-cloud",
  storageBucket: "mogul-cloud.firebasestorage.app",
  messagingSenderId: "1043961789377",
  appId: "1:1043961789377:web:1d2e6ee20e3c063f360d40",
  measurementId: "G-E300LRSJPL",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export const storage = getStorage(app);
